import {
  takeEvery,
  takeLeading,
  put,
  select,
  call,
  delay,
  fork,
} from 'redux-saga/effects';
import { isEmpty } from 'lodash';

import apiSaga from 'sagas/apiSaga';
import { getResultAPISaga } from './resultRetrievalSagas';

import {
  CREATE_RESULT,
  CREATE_RESULT_SUCCESS,
  GET_RESULT_SUCCESS,
} from 'actionTypes';
import { createResultSuccess, createResultFailure } from 'actions';

const PENDING_STATUS = 'pending';
const POLL_INTERVAL = 1000; //ms

// This file is concerned with the Result creation workflow
// 1. Making the create result request
// 2. Polling if the returned result is not ready.

function* createResultsSaga(action) {
  let response = yield call(apiSaga, action, action.payload);
  if (isEmpty(response.errors)) {
    const userId = yield select(state => state.auth.currentUserId);
    yield put(createResultSuccess(response, userId));
  } else {
    yield put(createResultFailure(response));
  }
}

function* pollForResultCompletionSaga(action) {
  const { result } = action;

  if (result.status === PENDING_STATUS) {
    yield delay(POLL_INTERVAL);
    yield fork(getResultAPISaga);
  }
}

export default [
  takeEvery(CREATE_RESULT, createResultsSaga),
  takeLeading(CREATE_RESULT_SUCCESS, pollForResultCompletionSaga),
  takeEvery(GET_RESULT_SUCCESS, pollForResultCompletionSaga),
];



// WEBPACK FOOTER //
// ./src/sagas/resultSagas/resultCreationSagas.js